import * as gs from './_csGbl';
import * as f from './_cmFTH';

import * as hf from './_hf';
import * as ht from './_ht';
import * as ihd from 'src/ihd';

//export { L } from './_cv_51a';
//export { saveAsync, D } from './_cv_51b';
export const itl_51z = () => ({ // 新規登録を考慮し、毎回新規生成
  _50rz: {},
  _51rz: {},
}) as ht.dz;

export const crt_51z = async () => {
  const _gUserz = gs.useUserz();
  const __51z = itl_51z();
  hf.udtDz(__51z._50rz, {
    ... ihd.i('_50r'),
  });
  hf.udtDz(__51z._51rz, {
    ... ihd.i('_51r'),
    _51r_31r1f: _gUserz.crt._31rz._fst,
  });
  return __51z;
};

/*
export const load_51rRzAsync = async (pz: {
  cdn: ht.s,
}) => {
  const _rz = {} as ht.dz;
  const _cdn1 = f.vdd(false, false);
  const _ls1 = await f.loadLsAsync({
    tgt: '_50rs',
    cdn: _cdn1,
    fld: '*',
  });
  _ls1.map((_dz: ht.dz) => {
    _rz[_dz._icn] = _dz._50ra1100t;
  })
  let _cdn2 = f.vdd();
  if (pz?.cdn) _cdn2 += ` AND (${pz.cdn})`;
  const _ls2 = await f.loadLsAsync({
    tgt: '_51rs',
    cdn: _cdn2,
  });
  _ls2.map((_dz: ht.dz) => {
    _rz[_dz._icn] = _dz._51ra1100t;
  })
  return _rz;
};
*/
export const load_51rRzAsync = async (pz: {
  _31r_fst: ht.n,
}) => {
  const _rz = {} as ht.dz;
  const _cdn1 = f.vdd(false, false);
  const _ls1 = await f.loadLsAsync({
    tgt: '_50rs',
    cdn: _cdn1,
  });
  hf.nn(_ls1).map((_dz: ht.dz) => {
    _rz[_dz._icn] = _dz._50ra1100t;
  })
  let _cdn2 = f.vdd();
//  if (pz?.cdn) _cdn2 += ` AND (${pz.cdn})`;
  _cdn2 += ` AND (
    (_51r_31r1f = ${pz._31r_fst ?? -1} AND 20 = (SELECT _50rt2100i FROM _50rs WHERE ${f.vdd(false, false)} AND _50rs._icn = _51rs._icn))
    OR (_51r_31r1f = 0 AND 20 <> (SELECT _50rt2100i FROM _50rs WHERE ${f.vdd(false, false)} AND _50rs._icn = _51rs._icn))
  )`; // 部門個別は個別
  const _ls2 = await f.loadLsAsync({
    tgt: '_51rs',
    cdn: _cdn2,
  });
  _ls2.map((_dz: ht.dz) => {
    _rz[_dz._icn] = _dz._51ra1100t;
  })
  return _rz;
};

export const load_51rDzAsync = async (pz: {
  _31r_fst: ht.n,
  _50r_icn: ht.s,
  vsn?: ht.n,
  //cdn?: ht.s,
}) => {
  const _cdn1 = f.vdd(false, false) + ` AND _icn = '${pz._50r_icn}'`;
  const _dz1 = await f.loadDzAsync({
    tgt: '_50rs',
    cdn: _cdn1,
  });
  const _31r_fst =
    _dz1._50rt2100i == 20 ?  // 部門個別
      pz._31r_fst 
    : 0; // 部門共通
//  let _cdn2 = f.vdd() + ` AND _icn='${pz._50r_icn}'`;
  let _cdn2 = (pz?.vsn && pz?.vsn > 0) ? (f.vdd(false) + ` AND _vsn = ${pz?.vsn}`) : f.vdd();
  _cdn2 += ` AND _icn = '${pz._50r_icn}'`;
  _cdn2 += ` AND _51r_31r1f = ${_31r_fst}`
  //if (pz.cdn) _cdn2 += ` AND (${pz.cdn})`;
  const _dz2 = await f.loadDzAsync({
    tgt: '_51rs',
    cdn: _cdn2,
  });
  if (!hf.f(_dz2)) {
    hf.udtDz(_dz2, {
//      _51r_31r1f: _gUserz.crt._31rz._fst,
//      _51r_31r1f: pz._31r_fst,
      _51r_31r1f: _31r_fst,
      _icn: pz._50r_icn,
      _51ra1100t: _dz2._51ra1100t ?? _dz1._50ra1100t,
    })
  }
  return {
    _50rz: _dz1,
    _51rz: _dz2,
  };
};

export const save_51rDzAsync = async (pz: {
  _51z: ht.dz,
}) => {
  const _dz = await f.ugdDzAsync({
    tgt: '_51rs',
    dz: {
      ... pz._51z._51rz,
    },
  });
  return {
    _51rz: { ... _dz, cldz: undefined },
  };
};
